//默认导入
const { ccclass, property } = cc._decorator;
import ModuleBase, { ViewLayer, moduleInit, bindButtonClickEvent } from "../../../../framework/core/mvvm/module_base";
import DialogReceiveView from "./dialog_receive_view";
import AudioManager from "../../../../manager/audio_manager";
import ModuleManager from "../../../../framework/core/module_manager";
import Bag from "../../../hall/module/bag/bag";

@ccclass
@moduleInit("DialogReceive")
export default class DialogReceive extends ModuleBase<DialogReceiveView, null> {

    protected m_schedule_id: number = 0
    protected m_intentData: any = null
    constructor() {
        super();
        this.package = "public";
        this.layer = ViewLayer.Highest;
        this.windowPrefabResPath = "package/public/dialog_huode";
        this.viewType = DialogReceiveView;
        this.needAnim = false
        this.needViewMask = true
        this.clickAnywhereClose = false
    }

    onShow(intentData) {
        let dataList
        if(!(intentData instanceof Array)){            
            dataList = []
            if(intentData.chipNum){
                dataList.push({type: 5, num: intentData.chipNum})
            }
            if(intentData.goldNum){
                dataList.push({type: 6, num: intentData.goldNum})
            }
        }else{
            dataList = intentData
        }
       this.view.showPanel(dataList)
       AudioManager.instance.playSound('sound/public/receive')
       this.cancelAllSchedule()
       this.m_schedule_id = this.doScheduleOnce(()=>{
           this.m_schedule_id = 0
            this.view.playBgAnim(false, ()=>{
                this.hide()
            })
       }, 3)
    }


    @bindButtonClickEvent('confirmBtn')
    protected on_click_confirm_btn(node: cc.Node){
        if(!this.m_schedule_id){
            return
        }
        this.cancelAllSchedule()
        this.hide()
    }

    @bindButtonClickEvent('goUseBtn')
    protected on_click_go_use_btn(node: cc.Node){
        this.on_click_confirm_btn(node)
        ModuleManager.instance.showModule(Bag, {tag: 'tag_daoju'})
    }
}